import { useEffect, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import Card from '../../components/Card';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';
import { FaAngleDown, FaAngleLeft, FaAngleRight, FaAnglesLeft } from "react-icons/fa6";
import LostCardBody from './LostCardBody';
import InfiniteScroll from 'react-infinite-scroll-component';
import loader from "../../assets/images/page-img/page-load-loader.gif";
import axios from 'axios';
import QR1 from "../../assets/QR1/qr1.png";

const CreateQrcLost = ({}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [qrcData, setQrcData] = useState(null);
    const [desPage, setDesPage] = useState(null);
    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');
    const [qrcId, setQrcId] = useState(null);
    const [deviceCode, setDeviceCode] = useState(null);
    const [itemName, setItemName] = useState(null);
    const [itemDescription, setItemDescription] = useState(null);
    const [photos, setPhotos] = useState([]);
    const [devices, setDevices] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    useEffect(() => {
       handleGetQrc();
    }, []);
    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };
    const handleGenerateQrc = async (e) => {
        e.preventDefault();
        const data = {
            
        }
        
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/qrc/lost-and-found/generate`,data,{
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            );
            toast.success(response?.data?.message);
            handleGetQrc();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    const handleGetQrc = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/qrc/all?platform=lost-and-found`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setQrcData(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching qrc", error);
        }
    }
    const handleSubmit = async (e,uId) => {
        e.preventDefault();
        if (!itemName) {
            toast.error('Device Name required');
            return;
        }
        if (!itemDescription) {
            toast.error('Device Description required');
            return;
        }
        if (uploadedFiles?.length === 0) {
            toast.error('Please upload images!');
            return;
        }
        try {
            const dataToSent = {
                'qrc_UID':uId,
                "deviceCode": deviceCode,
                "itemName": itemName,
                "itemDescription": itemDescription,
                "devicePhotos": uploadedFiles
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/device/add`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            // handleGetAllDevices();
            toast.success("Device added successfully!");
            window.history.back();
            setDesPage(null);
            setDeviceCode('');
            setItemName('');
            setItemDescription('');
            setUploadedFiles([]);

        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
        finally {
            // setShow(false);
        }
    }
    const handleFileInputChange = async (event) => {
        const chosenFiles = Array.prototype.slice.call(event.target.files)
        const uploaded = [...photos];
        chosenFiles.some((file) => {
            uploaded.push(file);
        })
        setPhotos(uploaded)
        try {
            const formData = new FormData();
            uploaded.forEach((file) => {
                formData.append('files', file)
            })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            toast.success(response?.data?.message);
            setUploadedFiles(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">
                <Container>
                    <Row>
                        <Col lg={8} className="row m-0 p-0">
                            <Card>
                                <Card.Body>
                                    <div className="w-100 mt-3 d-flex  align-items-center gap-3  px-2" >
                                    <FaAnglesLeft style={{ fontSize: "15px" }} onClick={() => window.history.back()} />
                                        <Button onClick={handleGenerateQrc}>+ Create QRC</Button >
                                    </div>
                                    <div className="d-flex align-items-center mt-4" >
                                        <div className="w-100"  >
                                            {
                                                qrcData ? qrcData?.map((i, index) =>
                                                    <>
                                                        <div key={i?._id}
                                                            className={`${index === desPage ? 'text-primary' : ''} d-flex flex-column justify-content-between align-items-center gap-2 w-100`}
                                                            style={{ borderBottom: "1px solid #dee2e682" }}
                                                            onClick={() => { setDesPage(desPage === index ? null : index); setQrcId(i?._id) }}
                                                        >
                                                            <div className="d-flex justify-content-between align-items-center gap-2 w-100 py-3">
                                                                <div>
                                                                    <img src={i?.qrCodeUrl ? i?.qrCodeUrl : QR1} alt="qr" width={70} height={70}
                                                                        onClick={() => { handleQrClick(i?.qrCodeUrl) }}
                                                                    />
                                                                    <span style={{ fontSize: "18px" }}>{`${i?.qrc_UID}-${index + 1}`}</span>
                                                                </div>
                                                                <div>
                                                                    {
                                                                        index === desPage ?
                                                                            <FaAngleDown style={{ fontSize: "20px" }} />
                                                                            :
                                                                            <FaAngleRight style={{ fontSize: "20px" }} />
                                                                    }
                                                                </div>
                                                            </div>

                                                        </div>
                                                         <Modal
                                                         size="lg"
                                                         className="fade text-center d-flex justify-content-center align-items-center modal-width"
                                                         id="post-modal"
                                                         onHide={()=>setDesPage(null)}
                                                         show={index === desPage}
                                                         style={{ overflow: "hidden" }}
                                                     >
                                                         <Modal.Header className="d-flex justify-content-between">
                                                             <Modal.Title id="post-modalLabel">
                                                                 Connect to Device
                                                             </Modal.Title>
                                                             <Link to="#" className="lh-1" onClick={()=>setDesPage(null)}>
                                                                 <span className="material-symbols-outlined">close</span>
                                                             </Link>
                                                         </Modal.Header>
                                                         <Modal.Body
                                                             style={{ maxHeight: "550px", overflowY: "auto" }}
                                                         >
             
                                                             <form
                                                                 className="post-text w-100 "
                                                             // onSubmit={handleSubmit}
                                                             >
                                                                 <input
                                                                     className="form-control rounded "
                                                                     type="text"
                                                                     placeholder="Enter Device code"
                                                                     style={{ border: "none", borderBottom: "2px solid #cfcfcf" }}
                                                                     value={i?.qrc_UID}
                                                                    //  onChange={(e) => setDeviceCode(e.target.value)}
                                                                     disabled
                                                                 />
                                                                 <input
                                                                     className="form-control rounded mt-3"
                                                                     type="text"
                                                                     placeholder="Item Name"
                                                                     style={{ border: "none", borderBottom: "2px solid #cfcfcf" }}
                                                                     value={itemName}
                                                                     onChange={(e) => setItemName(e.target.value)}
                                                                     required
                                                                 />
                                                                 <input
                                                                     className="form-control rounded mt-3"
                                                                     type="text"
                                                                     placeholder="Item Description"
                                                                     style={{ border: "none", borderBottom: "2px solid #cfcfcf" }}
                                                                     value={itemDescription}
                                                                     onChange={(e) => setItemDescription(e.target.value)}
                                                                     required
             
                                                                 />
                                                                 <label
                                                                     htmlFor="file-input"
                                                                     style={{ cursor: "pointer", width: "100%" }}
                                                                 >
             
                                                                     <input
                                                                         id="file-input"
                                                                         type="file"
                                                                         name="image"
                                                                         accept="image/*,.doc,.pdf,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                                         multiple
                                                                         style={{ display: "none" }}
                                                                         onChange={handleFileInputChange}
                                                                     />
             
                                                                     <p className="w-100 mt-3 bg-white border-0 text-primary "> + Add photos</p>
                                                                     <div className="d-flex gap-3 ">
                                                                         {
                                                                             uploadedFiles?.map(img =>
             
                                                                                 <img src={img} style={{ width: "80px", height: "80px" }} className="rounded" alt="img" />
                                                                             )
                                                                         }
                                                                     </div>
             
                                                                 </label>
             
             
                                                                 <Button className="w-100 mt-3" type="submit" onClick={(e)=>handleSubmit(e,i?.qrc_UID)}>Done</Button>
                                                             </form>
             
                                                         </Modal.Body>
                                                     </Modal>
                                                    </>
                                                ) :

                                                    <div>No Qrc Saved</div>
                                            }

                                        </div>
                                    </div>

                                    <Modal size="md" className="fade" id="qr-modal" style={{ backdropFilter: "blur(100px)" }} onHide={() => setQrPopupOpen(false)} show={qrPopupOpen} centered >
                                        <Modal.Header closeButton>
                                            <Modal.Title>QR Code</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="text-center">
                                            <img src={qrImageUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
                                        </Modal.Body>

                                    </Modal>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default CreateQrcLost
